import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import React, { forwardRef, memo, useContext, useMemo, useState, } from 'react';
import MuiMenuList from '@material-ui/core/MenuList';
import { combineClasses, styled, useId, useThemeProps, } from '../../../foundation';
import { RcSubMenuContext } from '../SubMenu/SubMenuContext';
import { RcMenuListContext } from './MenuListContext';
import { MenuListStyle } from './styles';
import { RcMenuListClasses } from './utils';
var MemoMuiListMenu = memo(MuiMenuList);
var _RcMenuList = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcMenuList' });
    var classesProp = props.classes, children = props.children, autoClose = props.autoClose, onCloseProp = props.onClose, maxHeight = props.maxHeight, rest = __rest(props, ["classes", "children", "autoClose", "onClose", "maxHeight"]);
    var _a = __read(useState(null), 2), focusedMenuItemId = _a[0], setFocusedMenuItemId = _a[1];
    var id = useId('menu-list', true);
    var classes = useMemo(function () { return combineClasses(RcMenuListClasses, classesProp); }, [classesProp]);
    var subMenuContext = useContext(RcSubMenuContext);
    var ctxValue = useMemo(function () { return ({
        menuListId: id,
        autoClose: !!autoClose || subMenuContext.autoClose,
        focusedMenuItemId: focusedMenuItemId,
        setFocusedMenuItemId: setFocusedMenuItemId,
        onClose: onCloseProp,
    }); }, [autoClose, focusedMenuItemId, id, onCloseProp, subMenuContext.autoClose]);
    return (React.createElement(RcMenuListContext.Provider, { value: ctxValue },
        React.createElement(MemoMuiListMenu, __assign({}, rest, { ref: ref, classes: classes }), children)));
});
var RcMenuList = styled(_RcMenuList)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), MenuListStyle);
RcMenuList.defaultProps = {
    variant: 'selectedMenu',
};
RcMenuList.displayName = 'RcMenuList';
export { RcMenuList, RcMenuListContext };
var templateObject_1;
